import { Card, Grid, Divider } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";

import Box from "../../components/Box";
import useStrings from "../../hooks/useStrings";

import { MainComponent } from "../main";
import { IUserProfile } from "../../commons/interfaces";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";
import { HeaderInfo, UserContact, ChangeEmail, PersonalInfo, ChangePassword, SidaNavBarProfile } from "../../components/Profile";

export enum ChangeMode {
    Profile = 0,
    Password = 1,
    Email = 2,
    OtpCode = 3,
}

interface ISideNavItem {
    icon: string;
    label: string;
    href: string;
}

enum ModeHrefProfile {
    BasicInfo = "basic-info",
    HeaderInfo = "header-info",
    PersonalInfo = "personal-info",
    UserContact = "user-contact",
    ChangeEmail = "change-email",
    ChangePassword = "change-password",
}

interface IProps {
    listChildren?: ReactNode[];
    sideNavItems?: ISideNavItem[];

    isMultiCardContainer: boolean;


    hidenCardInfoProfile?: {
        hidenIdCardInfo?: boolean;
        hidenPassportInfo?: boolean;
        hidenUserProfileByOrganization?: boolean;
    };

    hidenCardChangeEmail?: boolean;
    hidenCardChangePassword?: boolean;
    hidenCardChangeUserContact?: boolean;
    hidenTabTwoFactorAuthentication?: boolean;

    onDataUserProfile: (data: IUserProfile) => void;
}

const ProfileContainer = ({
    listChildren,
    sideNavItems,
    isMultiCardContainer,

    hidenCardInfoProfile,
    hidenCardChangeEmail,
    hidenCardChangePassword,
    hidenCardChangeUserContact,
    hidenTabTwoFactorAuthentication,

    onDataUserProfile,
}: IProps) => {
    const strings = useStrings();

    const {
        language,
        userInfo,
        tenantCode,
        serviceCode,
        onError,
        onSuccess,
        onShowLoading,
        onHideLoading
    } = useCommonComponentContext();

    const [newSideNavItems, setNewSideNavItems] = useState<ISideNavItem[]>([]);

    useEffect(() => {
        if (isMultiCardContainer) {
            const temp: ISideNavItem[] = [
                { icon: "receipt_long", label: strings.Profile.BASIC_INFO, href: ModeHrefProfile.BasicInfo },
                ...(sideNavItems || []),
            ];
            setNewSideNavItems(temp);
        } else {
            let temp: ISideNavItem[] = [
                { icon: "person", label: strings.Profile.PROFILE, href: ModeHrefProfile.HeaderInfo },
                { icon: "receipt_long", label: strings.Profile.PERSONAL_INFORMATION, href: ModeHrefProfile.PersonalInfo },
            ];

            !hidenCardChangeUserContact && temp.push({
                icon: "perm_contact_calendar",
                label: strings.Profile.USER_CONTACT,
                href: ModeHrefProfile.UserContact
            });

            !hidenCardChangeEmail && temp.push({
                icon: "email",
                label: strings.Profile.UPDATE_EMAIL,
                href: ModeHrefProfile.ChangeEmail
            });

            !hidenCardChangePassword && temp.push({
                icon: "security",
                label: strings.Profile.SECURITY,
                href: ModeHrefProfile.ChangePassword
            });

            if ((sideNavItems || []).length > 0) {
                temp = [...temp, ...sideNavItems];
            };

            setNewSideNavItems(temp);
        }
    }, [
        strings,
        sideNavItems,
        isMultiCardContainer,
        hidenCardChangeEmail,
        hidenCardChangePassword,
        hidenCardChangeUserContact,
    ]);

    const newListContainers: any = [
        <HeaderInfo
            idHref={ModeHrefProfile.HeaderInfo}
            userProfile={userInfo?.userProfile}
            listOrganization={userInfo?.listOrganization}

            onChangeAvatar={(data) => {
                const newData = {
                    ...userInfo?.userProfile,
                    avatarId: data.avatarId,
                    avatarUrl: data.avatarUrl,
                };
                onDataUserProfile(newData);
            }}

            onError={onError}
            onSuccess={onSuccess}
            onLoading={(val) => { val ? onShowLoading() : onHideLoading(); }}
        />,
        <PersonalInfo
            userProfile={userInfo?.userProfile}
            idHref={ModeHrefProfile.PersonalInfo}

            hidenIdCardInfo={hidenCardInfoProfile?.hidenIdCardInfo}
            hidenPassportInfo={hidenCardInfoProfile?.hidenPassportInfo}
            hidenUserProfileByOrganization={hidenCardInfoProfile?.hidenUserProfileByOrganization}

            onChangeUserProfile={(data) => {
                onDataUserProfile(data);
            }}

            onError={onError}
            onSuccess={onSuccess}
            onLoading={(val) => { val ? onShowLoading() : onHideLoading(); }}
        />,

        !hidenCardChangeUserContact &&
        <UserContact
            idHref={ModeHrefProfile.UserContact}
            idUserProfile={userInfo?.userProfile?.id}

            onError={onError}
            onSuccess={onSuccess}
            onLoading={(val) => { val ? onShowLoading() : onHideLoading(); }}
        />,

        !hidenCardChangeEmail &&
        <ChangeEmail
            tenantCode={tenantCode}
            serviceCode={serviceCode}
            userProfile={userInfo?.userProfile}
            idHref={ModeHrefProfile.ChangeEmail}

            onChangeEmail={(email) => {
                const newData = {
                    ...userInfo?.userProfile,
                    email: email,
                };
                onDataUserProfile(newData);
            }}

            onError={onError}
            onSuccess={onSuccess}
            onLoading={(val) => { val ? onShowLoading() : onHideLoading(); }}
        />,

        !hidenCardChangePassword &&
        <ChangePassword
            tenantCode={tenantCode}
            serviceCode={serviceCode}
            idHref={ModeHrefProfile.ChangePassword}
            onError={onError}
            onSuccess={onSuccess}
            onLoading={(val) => { val ? onShowLoading() : onHideLoading(); }}
            hidenTabTwoFactorAuthentication={hidenTabTwoFactorAuthentication}
        />,
    ];

    const renderView = () => (
        <Grid container spacing={3}>
            {isMultiCardContainer
                ? (
                    <Grid item xs={12}>
                        <Card id={ModeHrefProfile.BasicInfo}>
                            {newListContainers
                                .filter((el: any) => el !== false)
                                .map((itemComponent: any, index: number) => (
                                    <Box key={`box_${index}`}>
                                        {itemComponent}
                                        <Box mx={2}>
                                            <Divider />
                                        </Box>
                                    </Box>
                                ))
                            }
                        </Card>
                    </Grid>
                )
                : (
                    newListContainers
                        .filter((el: any) => el !== false)
                        .map((itemComponent: any, index: number) => (
                            <Grid key={`gr_${index}`} item xs={12}>
                                <Card>{itemComponent}</Card>
                            </Grid>
                        ))
                )
            }
            {/* // */}
            {[...(listChildren || [])].length > 0 &&
                [...(listChildren || [])].map((itemComponent, index) => (
                    <Grid key={`gr_${index}`} item xs={12}>
                        <Card>{itemComponent}</Card>
                    </Grid>
                ))}
        </Grid>
    );
    
    return (
        <MainComponent>
            <Grid key={`ma_${language}`} container spacing={3}>
                <Grid item xs={12} lg={3}>
                    <SidaNavBarProfile sideNavItems={newSideNavItems} />
                </Grid>
                <Grid item xs={12} lg={9}>
                    <Box mb={3}>{renderView()}</Box>
                </Grid>
            </Grid>
        </MainComponent>
    );
};

export default ProfileContainer;
